// extracted by mini-css-extract-plugin
export default {"questions":"Sections-module__questions__KGv5V","question":"Sections-module__question__yNIo4","sectionTitle":"Sections-module__sectionTitle__p1ev0"};